// Placeholder CONF (confirmation) field for the Game Attendance table.
// TODO(BE): replace with the confirmed field name once BE finalizes it.
// Tracker: docs/MOCK_DATA_TO_REMOVE_GAME_ATTENDANCE.md
// Deliberately NOT `is_proposed_starting` (owned by the goalie-exclusive
// starting logic + "select a starting goalie" alert).
export const CONF_FIELD = 'is_confirmed' as const

export const getPlayerConfirmed = (player: any): boolean =>
  Boolean(player?.[CONF_FIELD])
